// extracted by mini-css-extract-plugin
export default {"loadingContainer":"app_loadingContainer__gzcce","container":"app_container__XBPJS"};